import React, { useContext, useState } from 'react';
import { Pills, Pill } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../../contexts/EnvironmentContext';
import { VEHICLE_TYPE_EV, VEHICLE_TYPES } from '../../../../../constants/vehicleTypes';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { trackGAEvent } from '../../../utils/gaTracking';

import Classes from './VehicleNavigationBar.module.scss';

const URLS = {
  [VEHICLE_TYPE_EV]: '/cp/91/elektrische-auto-kopen/',
  [VEHICLE_TYPES.CARS]: '/cp/91/auto-kopen/',
};

const VehicleNavigationApp = () => {
  const { t } = useI18nContext();
  const { vehicleTypes, pageVehicleType } = useContext(EnvironmentContext);
  const isEvPage = pageVehicleType === VEHICLE_TYPE_EV;
  const [currentVehicle, setCurrentVehicle] = useState(
    isEvPage ? vehicleTypes.findIndex((type) => type === VEHICLE_TYPE_EV) : 0,
  );

  const handlePillClick = (index: number) => {
    setCurrentVehicle(index);
    const updatedVehicleType = vehicleTypes[index];
    if (
      updatedVehicleType === VEHICLE_TYPE_EV ||
      currentVehicle === vehicleTypes.findIndex((vehicle) => vehicle === VEHICLE_TYPE_EV)
    ) {
      const url = updatedVehicleType === VEHICLE_TYPE_EV ? URLS[VEHICLE_TYPE_EV] : URLS[VEHICLE_TYPES.CARS];
      history.pushState(history.state, '', url);
    }
    window.dispatchEvent(new CustomEvent('vehicle-type-changed', { detail: updatedVehicleType }));
    trackGAEvent('l1TabSelected', updatedVehicleType);
  };

  return (
    <div className={Classes.root}>
      <Pills className={Classes.scrollView}>
        {vehicleTypes.map((vehicle, index) => (
          <Pill
            isActive={currentVehicle === index}
            onClick={() => handlePillClick(index)}
            translations={{
              ariaLabelDefault: t('cars.browse.section'),
              ariaLabelActive: t('cars.browse.current'),
            }}
            key={vehicle}
          >
            {t(`cars.browse.${vehicle}`)}
          </Pill>
        ))}
      </Pills>
    </div>
  );
};

export default VehicleNavigationApp;
